import { render, staticRenderFns } from "./receivedCoachBalance.vue?vue&type=template&id=48e81f37&"
import script from "./receivedCoachBalance.vue?vue&type=script&lang=js&"
export * from "./receivedCoachBalance.vue?vue&type=script&lang=js&"
import style0 from "./receivedCoachBalance.vue?vue&type=style&index=0&id=48e81f37&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports